export default "__VITE_ASSET__ead301b5__"